import { createFileRoute } from '@tanstack/react-router';
import { EmailLettersPage } from '../features/admin/email-letters-page.js';

export const Route = createFileRoute('/app/admin/emails')({
  component: EmailLettersPage,
});
